import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig } from 'platformConfig'

export type MembershipLevelsConfig = {
  hasPremium: boolean
  hasPremiumMax: boolean
}

export const MEMBERSHIP_LEVELS_CONFIG: Partial<Record<PlatformSlug, MembershipLevelsConfig>> = {
  [PlatformSlug.DATBooster]: { hasPremium: true, hasPremiumMax: true },
  [PlatformSlug.OATBooster]: { hasPremium: true, hasPremiumMax: true },
  [PlatformSlug.DATCrusher]: { hasPremium: true, hasPremiumMax: true },
  [PlatformSlug.PATBooster]: { hasPremium: true, hasPremiumMax: true },
  [PlatformSlug.NBDHEBooster]: { hasPremium: true, hasPremiumMax: true },
  [PlatformSlug.INBDEBooster]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.NDEBCrusher]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.CasperBooster]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.CARSBooster]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.GREBooster]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.NBEOPartOne]: { hasPremium: false, hasPremiumMax: false },
  [PlatformSlug.DLOSCE]: { hasPremium: true, hasPremiumMax: false },
  [PlatformSlug.MCATBooster]: { hasPremium: false, hasPremiumMax: false },
  [PlatformSlug.Admissions]: { hasPremium: false, hasPremiumMax: false },
}

export const getMembershipLevelsConfig = (slug?: PlatformSlug) => getFeatureConfig(MEMBERSHIP_LEVELS_CONFIG, slug)
